import { render, staticRenderFns } from "./FailedTestLogsDetails.vue?vue&type=template&id=246192b3&scoped=true"
import script from "./FailedTestLogsDetails.vue?vue&type=script&lang=js"
export * from "./FailedTestLogsDetails.vue?vue&type=script&lang=js"
import style0 from "./FailedTestLogsDetails.vue?vue&type=style&index=0&id=246192b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246192b3",
  null
  
)

export default component.exports